module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/461.0c980f5b.png";